import type { ScrollListParams } from "@/lib/api/queries/scrolls";
import type { SearchScope } from "@/lib/search/types";

export const queryKeys = {
  currentUser: () => ["current-user"] as const,
  workspaces: () => ["workspaces"] as const,
  folders: (workspaceId?: string | null) =>
    ["folders", workspaceId ?? "all"] as const,
  scrolls: (params?: ScrollListParams) =>
    [
      "scrolls",
      params?.workspaceId ?? "all",
      params?.folderId ?? "all",
      params?.folder ?? "all",
      params?.limit ?? 30,
      params?.archived ?? "active",
      params?.deleted ?? "active",
      params?.q?.trim()?.slice(0, 200) ?? "",
      params?.starredOnly ? 1 : 0,
      params?.inFolderOnly ? 1 : 0,
    ] as const,
  homeMomentum: (workspaceId: string | null, timeZone: string) =>
    ["home-momentum", workspaceId ?? "none", timeZone] as const,
  workspaceSearch: (params: {
    workspaceId: string | null;
    q: string;
    scope: SearchScope;
    folderId?: string | null;
    starredOnly?: boolean;
    limit?: number;
  }) =>
    [
      "workspace-search",
      params.workspaceId ?? "none",
      params.scope,
      params.q,
      params.folderId ?? "",
      params.starredOnly ? 1 : 0,
      params.limit ?? 0,
    ] as const,
  systemAvatars: () => ["system-avatars"] as const,
  planUsage: () => ["plan-usage"] as const,
  publishedLinks: () => ["published-links"] as const,
};
